/* eslint-disable no-unused-vars */
export default class GenerateOverdueInvoiceChargesClientDTO {
  constructor({
    overdueInvoiceID,
    expectedUnchargedInterestExTax = null,
  } = {}) {
    /**
     * @type {Number}
     */
    this.overdueInvoiceID = overdueInvoiceID
    /**
     * @type {Number}
     */
    this.expectedUnchargedInterestExTax = expectedUnchargedInterestExTax
  }
}
